import React from 'react';
import { Search, MoreHorizontal, Circle } from 'lucide-react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function FloatingSearchBar() {
  const {
    scrollY
  } = useScroll();
  const backgroundColor = useTransform(scrollY, [0, 100], ['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 1)']);
  const boxShadow = useTransform(scrollY, [0, 100], ['none', '0 4px 6px -1px rgb(0 0 0 / 0.1)']);
  const iconColor = useTransform(scrollY, [0, 100], ['#FFFFFF', '#333333']);
  const inputBg = useTransform(scrollY, [0, 100], ['rgba(255, 255, 255, 0.2)', 'rgba(243, 244, 246, 1)']);
  const inputTextColor = useTransform(scrollY, [0, 100], ['#FFFFFF', '#666666']);
  return <motion.header style={{
    backgroundColor,
    boxShadow
  }} className="fixed top-0 left-0 right-0 z-50 h-20 flex items-center px-4 transition-colors duration-300" data-id="element-46">
      <div className="flex-1 flex items-center gap-3" data-id="element-47">
        <motion.div style={{
        backgroundColor: inputBg
      }} className="flex-1 h-10 rounded-full flex items-center px-4 gap-2 backdrop-blur-sm" data-id="element-48">
          <Search className="size-4 text-gray-400" data-id="element-49" />
          <motion.span style={{
          color: inputTextColor
        }} className="text-sm" data-id="element-50">
            搜索景区/酒店/美食
          </motion.span>
        </motion.div>

        <div className="flex items-center bg-black/10 backdrop-blur-md rounded-full px-3 py-1.5 gap-3 border border-white/20" data-id="element-51">
          <MoreHorizontal className="size-5 text-white" data-id="element-52" />
          <div className="w-px h-4 bg-white/20" data-id="element-53" />
          <Circle className="size-5 text-white fill-white" data-id="element-54" />
        </div>
      </div>
    </motion.header>;
}